import {getFormData} from '../../utilities/helper/formDataConvertor';
import request from '../axios';

export const updateProfile = async (payload: IUpdateProfilePayload) => {
  const {data}: {data: IResponse} = await request.put(
    `/api/profile/supplier-profile`,
    getFormData(payload as unknown as {[name: string]: string | Blob}),
  );
  return data;
};

export const getProfile = async () => {
  const {data}: {data: IProfile} = await request.get(
    `/api/profile/user-profiles`,
  );

  return data;
};
